<!-- Color -->
<div class="form-group">
    <label>Fill color</label>
    <nirby-color-picker
        [value]="color"
        [allowTransparency]="true"
        (valueChange)="chooseColor($event)"
    ></nirby-color-picker>
</div>
